var _style, _path, _circle, _circle2, _circle3, _path2, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInsightsRelationships = function SvgInsightsRelationships(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "insights-relationships_svg__Light",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".insights-relationships_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.5h6M19.5 3.5h-2c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h2",
    className: "insights-relationships_svg__st0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 3.5,
    r: 2,
    className: "insights-relationships_svg__st0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 12.5,
    r: 2,
    className: "insights-relationships_svg__st0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 20.5,
    r: 2,
    className: "insights-relationships_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.5 23.5.5-6h2.5V14c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.5H3l.5 6z",
    className: "insights-relationships_svg__st0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 4,
    r: 3.5,
    className: "insights-relationships_svg__st0"
  })));
};
export default SvgInsightsRelationships;